const rootUrl = 'https://pmerj-digital-dev.pmerj.seg.br';

export const federationManifest = {
  'portal-root': `${rootUrl}/remoteEntry.json`,
  'portal-p1': `${rootUrl}/p1/remoteEntry.json`,
  'portal-gerenciamento': `${rootUrl}/gerenciamento/remoteEntry.json`,
  'portal-dgo': `${rootUrl}/dgo/remoteEntry.json`,
  'portal-dgs': `${rootUrl}/dgs/remoteEntry.json`,
  'portal-p3': `${rootUrl}/p3/remoteEntry.json`,
  'portal-sgi': `${rootUrl}/sgi/remoteEntry.json`,
  'portal-correcional': `${rootUrl}/correcional/remoteEntry.json`,
  'portal-p2': `${rootUrl}/p2/remoteEntry.json`,
  'portal-ssgp': `${rootUrl}/ssgp/remoteEntry.json`,
  'portal-cproeis': `${rootUrl}/cproeis/remoteEntry.json`,
  'portal-p4': `${rootUrl}/p4/remoteEntry.json`,
  'portal-publicacoes': `${rootUrl}/publicacoes/remoteEntry.json`,
  'meu-portal': `${rootUrl}/meu-portal/remoteEntry.json`,
};
